import { render } from "./App.vue?vue&type=template&id=565fe3c8"
const script = {}

import exportComponent from "/Users/ru1x89/Sites/ssi-protection/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__